/**
 * Manual <br> line breaks that must disappear on phones.
 *
 * The stylesheet hides them with `br { display: none }` under 768px, but some
 * Safari versions then also drop the space next to the <br>, so two words run
 * together ("CLIENT PARTNERSHIP" becomes "CLIENTPARTNERSHIP"). Swapping the
 * <br> for a real text space fixes that in every browser; the CSS rule stays
 * as a fallback when JavaScript is off.
 *
 * Titles directly inside a grid are handled by the Title component, and the
 * home intro title belongs to HomeHeroCover, so both are skipped here.
 */
const MOBILE_QUERY = "(max-width: 768px)"

const SELECTOR = [
    ".wp-block-cinetic-creatives-blocks-title br",
    ".wp-block-cinetic-creatives-blocks-text.has-x-medium-font-size br",
    ".ignore-space-mobile br",
].join(", ")

const SKIP = ".wp-block-cinetic-creatives-blocks-grid > .wp-block-cinetic-creatives-blocks-title, .home-hero-cover"

export default class LineBreaks {
    constructor({ el }) {
        this.el = el
        this.pairs = []
        this.mobile = null
        this.lastWidth = window.innerWidth

        this.apply()
        this.boundResize = this.handleResize.bind(this)
        window.addEventListener("resize", this.boundResize)
    }

    handleResize() {
        if (window.innerWidth === this.lastWidth) return
        this.lastWidth = window.innerWidth
        this.apply()
    }

    apply() {
        const mobile = window.matchMedia(MOBILE_QUERY).matches
        if (mobile === this.mobile) return
        this.mobile = mobile

        if (mobile) {
            this.el.querySelectorAll(SELECTOR).forEach(br => {
                if (br.closest(SKIP)) return
                const space = document.createTextNode(" ")
                br.replaceWith(space)
                this.pairs.push({ br, space })
            })
        } else {
            this.pairs.forEach(({ br, space }) => {
                if (space.parentNode) space.replaceWith(br)
            })
            this.pairs = []
        }
    }

    dispose() {
        window.removeEventListener("resize", this.boundResize)
    }
}
